<template>
  <div>
    <div class="columns mb-5">
      <div class="column has-text-centered">
        <a
          href="/assets/HousingTraining70.csv"
          download="Housing TRAINING Data - Close to Ocean - 1 means close.csv"
          >Don't have a training dataset? Download the demo .csv!</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
